
import Vue from 'vue';
import _trim from 'lodash/trim';
import { RunnitNodeDefProvider, ProviderMapping } from '@run-diffusion/shared';
import BaseButton from '@/components/base/BaseButton.vue';
import ClipboardCopy from '@/components/ClipboardCopy.vue';

export default Vue.extend({
	name: 'RunnitProviderMappingRow',
	components: {
		BaseButton,
		ClipboardCopy,
	},
	props: {
		index: { type: Number, required: true },
		mapping: { type: Object as () => ProviderMapping, required: true },
		oldMapping: { type: Object, default: null },
		fieldMappingsJson: { type: String, required: true },
		fieldMapBuildersJson: { type: String, required: true },
		oldFieldMappingsJson: { type: String, default: '{}' },
		oldFieldMapBuildersJson: { type: String, default: '{}' },
		providerItems: { type: Array, required: true },
		endpointIdsMap: { type: Object, required: true },
		isReadOnly: { type: Boolean, default: false },
		savingRunnitNodeDef: { type: Boolean, default: false },
		allowRemove: { type: Boolean, default: false },
		showNumResultsPath: { type: Boolean, default: false },
		canMoveUp: { type: Boolean, default: false },
		canMoveDown: { type: Boolean, default: false },
	},
	computed: {
		disabled (): boolean {
			return this.isReadOnly || this.savingRunnitNodeDef;
		},
		hasOldBaseline (): boolean {
			return !!this.oldMapping;
		},
		endpointItemsForProvider (): unknown[] {
			const provider: RunnitNodeDefProvider = this.mapping?.provider;
			if (!provider) return [];
			return this.endpointIdsMap?.[provider] || [];
		},
		numResultsKey (): string {
			return this.mapping?.staticFieldMappings?.numResults?.key || '';
		},
		numResultsPathRules (): ((v: string) => boolean | string)[] {
			if (!this.showNumResultsPath) return [];
			return [(v: string) => !!_trim(v || '') || 'Num Results Property Path is required'];
		},
	},
	methods: {
		_trim: _trim,
		onProviderChange (provider: string | null) {
			this.$emit('update-provider', { index: this.index, value: provider });
		},
		onEndpointChange (endpointId: string | null) {
			this.$emit('update-endpoint-id', { index: this.index, value: endpointId || '' });
		},
		onNumResultsPathInput (value: string) {
			this.$emit('update-num-results-key', { index: this.index, value: value || '' });
		},
		onFieldMappingsInput (value: string) {
			this.$emit('field-mappings-json', { index: this.index, value });
		},
		onFieldMapBuildersInput (value: string) {
			this.$emit('field-map-builders-json', { index: this.index, value });
		},
	},
});
